// extracted by mini-css-extract-plugin
export default {"listStats":"Stats--listStats--Bdymy"};